var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHydrationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.92193,
    y: 1.92193,
    width: 46.1562,
    height: 46.1562,
    rx: 6.07807,
    stroke: "white",
    strokeWidth: 2.15615
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.1739 26.9037C37.4939 26.5838 37.9053 26.1725 38.3153 25.7641C39.2282 24.8529 39.2282 23.3733 38.3153 22.4607L37.3482 21.4938C33.8867 24.9543 28.7081 25.6484 24.5566 23.5804C27.3623 24.0988 30.2709 23.6946 32.8482 22.3093C34.5724 21.3824 34.8996 19.046 33.5153 17.6621L27.8081 11.9565C26.5323 10.6812 24.4652 10.6812 23.1909 11.9565L17.0394 18.1062C21.0908 16.3853 25.9566 17.1836 29.2509 20.4999C24.2252 18.0605 17.998 18.926 13.825 23.0977C13.505 23.4176 13.0922 23.8303 12.6836 24.2388C11.7721 25.1514 11.7721 26.6296 12.6836 27.5407L13.6493 28.5061C17.1108 25.0457 22.2894 24.3516 26.4409 26.4196C23.6352 25.9012 20.7266 26.3053 18.1494 27.6907C16.4251 28.6176 16.0979 30.9541 17.4822 32.338L23.1894 38.0435C24.4652 39.3188 26.5323 39.3188 27.8066 38.0435L33.9582 31.8938C29.9067 33.6147 25.0409 32.8164 21.7466 29.5002C26.7723 31.9395 32.9995 31.074 37.1725 26.9023L37.1739 26.9037Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHydrationIcon);
export default __webpack_public_path__ + "static/media/Hydration_Icon.c2976d9274dbf583b9b90e977305cbd0.svg";
export { ForwardRef as ReactComponent };